import { Space, Text } from "@mantine/core";
import { MultiRadioTable } from "../../../components/MultiRadioTable";
import { TStaffSurveyCase } from "../../../types";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
  caso: TStaffSurveyCase;
  title: string;
  questionIds: string[];
};

const Component = ({ form, caso, title, questionIds }: Props) => {
  const { t, i18n } = useTranslation();

  // If current language is Spanish, use original texts from the database
  const isSpanish = i18n.language === 'es';

  let description, questionStatement, questions;

  if (isSpanish) {
    // Use original texts from the database
    description = caso.description;
    questionStatement = caso.question_statement;
    questions = [
      caso.case_resolution_statement,
      caso.natural_heterosexuality_statement,
      caso.exacerbated_intent_statement,
      caso.victim_responsibility_statement,
      caso.overreaction_statement,
      caso.ulterior_motives_statement,
    ];
  } else {
    // Use translations for other languages
    // Convert the case title to a translation key
    // e.g. "Caso Leandro - Con activador" -> "caso_leandro_con_activador"
    const caseTitleKey = caso.title
      .toLowerCase()
      .replace(/\s*-\s*/g, '_') // Replace " - " with "_"
      .replace(/\s+/g, '_') // Replace spaces with "_"
      .replace(/[^a-z0-9_]/g, '') // Remove non-alphanumeric characters except "_"
      .replace(/^_+|_+$/g, ''); // Remove leading and trailing "_"

    description = t(`cases.${caseTitleKey}.description`);
    questionStatement = t(`cases.${caseTitleKey}.question_statement`);
    questions = [
      t(`cases.${caseTitleKey}.case_resolution_statement`),
      t(`cases.${caseTitleKey}.natural_heterosexuality_statement`),
      t(`cases.${caseTitleKey}.exacerbated_intent_statement`),
      t(`cases.${caseTitleKey}.victim_responsibility_statement`),
      t(`cases.${caseTitleKey}.overreaction_statement`),
      t(`cases.${caseTitleKey}.ulterior_motives_statement`),
    ];
  }

  return (
    <>
      <Text size="lg">{title}</Text>
      <Space h="md" />
      <Text size="md">{description}</Text>
      <Space h="md" />
      <MultiRadioTable
        form={form}
        label={questionStatement}
        options={[
          { label: t("agreementOptions.0"), value: "Totalmente de acuerdo." },
          { label: t("agreementOptions.1"), value: "De acuerdo." },
          { label: t("agreementOptions.2"), value: "En desacuerdo." },
          { label: t("agreementOptions.3"), value: "Totalmente en desacuerdo." }
        ]}
        questions={questions}
        questionIds={questionIds}
      />
    </>
  );
};

export default Component;
